import {
  AltTransBusCoverage,
  AltTransStretchCoverage,
} from "features/CenterContent/RoleContent/AlternativeTransport/DecisionSupport/types";
import { isNotNullish } from "shared/utils/objectUtils";

export function calculateTotalRequiredFromBusCoverage(
  busCoverage: AltTransBusCoverage,
): number {
  if (busCoverage.totalRequired) return busCoverage.totalRequired;

  const busSum = Object.values(busCoverage)
    .filter(isNotNullish)
    .reduce((subtotal, current) => subtotal + current, 0);

  return busSum;
}

export function calculateTotalRequiredFromStretchCoverage(
  stretchCoverage: AltTransStretchCoverage,
): number {
  const blockSubtotals = stretchCoverage.busCoverageBlocks.map((timeBlock) =>
    calculateTotalRequiredFromBusCoverage(timeBlock.busCoverage),
  );

  const stretchSum = blockSubtotals.reduce(
    (subtotal, current) => subtotal + current,
    0,
  );

  return stretchSum;
}

export function aggregateStretchCoverage(
  stretchCoverage: AltTransStretchCoverage,
): AltTransBusCoverage {
  const busCoverage = stretchCoverage.busCoverageBlocks
    .map((block) => block.busCoverage)
    .reduce(
      (previous, current) => {
        const nextEntries = Object.entries(current).map(([key, value]) => [
          key,
          previous[key as keyof AltTransBusCoverage]! + (value ?? 0),
        ]);
        return Object.fromEntries(nextEntries);
      },
      {
        totalRequired: 0,
        totalOrdered: 0,
        totalConfirmed: 0,
        totalOperational: 0,
        stillRequired: 0,
        totalRequiredByMeasureCard: 0,
      },
    );

  return busCoverage;
}
export function getStretchCoverageTitle(
  stretchCoverage: AltTransStretchCoverage,
): string {
  return `${stretchCoverage.fromStation.jbvId}–${stretchCoverage.toStation.jbvId}`;
}
